import React from "react";
import * as FaIcons from "react-icons/fa"; // Import all Font Awesome icons
import * as MdIcons from "react-icons/md"; // Import all Font Awesome icons
import * as IoIcons from "react-icons/io"; // Import all Font Awesome icons
import * as PiIcons from "react-icons/pi"; // Import all Font Awesome icons
import * as Fa6Icons from "react-icons/fa6"; // Import all Font Awesome icons
import * as CgIcons from "react-icons/cg"; // Import all Font Awesome icons

const Icon = ({
  name,
  className = "",
  cursorPointer = true,
  notAllowed = false,
  onClick,
  size = "15",
  disabled = false,
  title = "",
  ...props
}) => {
  // Dynamically choose the icon based on the name
  const IconComponent =
    FaIcons[name] ||
    MdIcons[name] ||
    IoIcons[name] ||
    PiIcons[name] ||
    Fa6Icons[name] ||
    CgIcons[name];

  if (!IconComponent) return null;

  return (
    <IconComponent
      className={className}
      style={{
        cursor: cursorPointer ? "pointer" : notAllowed ? "not-allowed" : "",
      }}
      size={size}
      onClick={onClick}
      disabled={disabled}
      title={title}
      {...props}
    />
  );
};

export default Icon;
